import { createContext } from 'react'

// Canal fiable pour transmettre les actions sur événements (rafraîchir la
// liste, retirer localement un événement supprimé) jusqu'aux composants rendus
// PAR react-big-calendar (EventPopOverCard via components.event).
//
// Pourquoi un Context et pas les props / localizer.messages : react-big-calendar
// ne forwarde pas de props custom à ses composants d'événement, et le passage
// via localizer.messages ne transmet pas nos fonctions de façon fiable selon la
// version/build. Un Context, lui, traverse tout le sous-arbre quel que soit ce
// que RBC forwarde.
export const EventActionsContext = createContext({
  getAllEvents: null,
  removeEventLocally: null,
})
